/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./Footer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/* eslint-disable @atlaskit/design-system/no-html-anchor */

import { useState } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ConfluenceLogo } from '@atlaskit/logo';
import { N300, N30A } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
import { ANALYTICS_CHANNEL } from '../analytics';
var FOOTER_CONTENT_HEIGHT = 52;
var FOOTER_BORDER_PX = 2;
export var FOOTER_HEIGHT = FOOTER_CONTENT_HEIGHT + FOOTER_BORDER_PX;
var containerStyles = null;
var contentWrapperStyles = null;
var logoWrapperSyles = null;
var linkStyles = null;
export var Footer = function Footer(_ref) {
  var url = _ref.url,
    linkTooltip = _ref.linkTooltip,
    label = _ref.label;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "footer-container",
    className: ax(["_11c8dcr7 _kkesxnyv _x3do11us _4t3i1ex1 _syaz1vvm _1e0c1txw _4cvr1h6o _1bah1h6o"]),
    style: {
      "--_16sq3yh": ix("0 0 ".concat(FOOTER_CONTENT_HEIGHT, "px")),
      "--_bbz764": ix("var(--ds-text-subtle, ".concat(N300, ")")),
      "--_81dizw": ix("".concat(FOOTER_BORDER_PX, "px solid ", "var(--ds-border, ".concat(N30A, ")")))
    }
  }, url ? /*#__PURE__*/React.createElement(ContentAction, {
    tooltipText: linkTooltip,
    href: url
  }, function (_ref2) {
    var isHovered = _ref2.isHovered;
    return /*#__PURE__*/React.createElement(Content, {
      isHovered: isHovered,
      label: label
    });
  }) : /*#__PURE__*/React.createElement(Content, {
    label: label
  }));
};
var Content = function Content(_ref3) {
  var isHovered = _ref3.isHovered,
    label = _ref3.label;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_4t3i7vkz _1e0c1txw _1bah1h6o _4cvresu3"])
  }, label, /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _2lx21bp4 _1bah1h6o _19pkidpf _2hwxidpf _otyridpf _18u0u2gc"])
  }, /*#__PURE__*/React.createElement(ConfluenceLogo, {
    appearance: isHovered ? 'brand' : 'neutral',
    size: "xxsmall"
  })));
};
var ContentAction = function ContentAction(_ref4) {
  var children = _ref4.children,
    tooltipText = _ref4.tooltipText,
    href = _ref4.href;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var handleClick = function handleClick() {
    createAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'confluenceFooter',
      source: 'embeddedConfluenceViewPageScreen',
      eventType: 'ui'
    }).fire(ANALYTICS_CHANNEL);
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipText
  }, /*#__PURE__*/React.createElement("a", {
    href: href,
    target: "_blank",
    onMouseEnter: function onMouseEnter() {
      setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIsHovered(false);
    },
    onClick: handleClick,
    "data-testid": "link",
    className: ax(["_12ji1r31 _1qu2glyw _12y31o36 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1kw7 _16qsglyw _1q5t1r31 _nt751r31 _1dit1r31 _1ohyglyw _49pcglyw _ksodglyw _1r9x1o36 _1hvw1o36 _4hz81o36 _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _180dglyw _7ehiglyw _1dbzglyw"])
  }, children({
    isHovered: isHovered
  })));
};